import type { AiIdentity } from '@/lib/ai'

/** Fish vertical's branding/copy for the onX Guide chat. */
export const identity: AiIdentity = {
  agentName: 'onX Guide',
  productLabel: 'onX Fish',
  vertical: 'fish',
  emptyStateTitle: 'Your fishing companion, anytime.',
  emptyStateBody:
    'Ask onX Guide about the water, the weather, or where to go next.',
  starterPrompts: [
    { id: 'find-lake', label: 'Find a new lake to fish' },
    { id: 'weather', label: "What's the weather like?" },
    { id: 'what-can-you-do', label: 'What can onX Guide do?' },
  ],
}
